import MedicationFrecuency from './MedicationFrecuency.jsx';

export default MedicationFrecuency;